import { createStore } from "vuex";
import { config } from "vuex-module-decorators";

import AuthModule from "@/store/modules/AuthModule";
import BodyModule from "@/store/modules/BodyModule";
import ConfigModule from "@/store/modules/ConfigModule";
import ThemeModeModule from "@/store/modules/ThemeModeModule";
import ResidentsRegistrationsModule from "@/store/modules/ResidentsRegistrationsModule";
import AccountModule from "@/store/modules/AccountModule";
import VoidChequeModule from "@/store/modules/VoidChequeModule";
import ResidentModule from "@/store/modules/ResidentModule";
import AdministrativeFormModule from "@/store/modules/AdministrativeFormModule";
import DocumentModule from "@/store/modules/DocumentModule";

config.rawError = true;

const store = createStore({
  modules: {
    AuthModule,
    BodyModule,
    ConfigModule,
    ThemeModeModule,
    ResidentsRegistrationsModule,
    AccountModule,
    VoidChequeModule,
    ResidentModule,
    AdministrativeFormModule,
    DocumentModule,
  },
});

export default store;
